'use client';

// =============================================================================
// TonConnectButton — wrapper для @tonconnect/ui-react с нашим V2 styling.
//
// Когда юзер connect'ится — берём address и шлём в API чтобы сохранить
// в users.ton_address (используется для withdraw).
// =============================================================================

import { useTonAddress, useTonConnectUI } from '@tonconnect/ui-react';
import { useEffect, useRef } from 'react';

import { createApiClient } from '@/lib/api';
import { getInitData, hapticImpact } from '@/lib/tma';

export function TonConnectButton({ onConnected }: { onConnected?: (address: string) => void }) {
  const userAddress = useTonAddress();
  const [tonConnectUI] = useTonConnectUI();
  const lastSavedRef = useRef<string | null>(null);

  // При connect — сразу POST /api/me/ton-address. Идемпотентно — backend
  // обновит row только если адрес новый.
  useEffect(() => {
    if (!userAddress) return;
    if (lastSavedRef.current === userAddress) return;
    lastSavedRef.current = userAddress;
    const api = createApiClient(getInitData);
    api
      .saveTonAddress(userAddress)
      .then(() => onConnected?.(userAddress))
      .catch((err) => {
        console.warn('saveTonAddress failed', err);
      });
  }, [userAddress, onConnected]);

  if (userAddress) {
    return (
      <div className="bg-bg-elev p-3 border-l-[3px] border-accent">
        <div className="font-mono text-[10px] text-text-tertiary tracking-[0.15em] mb-1">
          ✓ КОШЕЛЁК ПОДКЛЮЧЁН
        </div>
        <div className="font-mono text-[11px] break-all">{userAddress}</div>
        <button
          onClick={() => {
            hapticImpact('light');
            tonConnectUI.disconnect();
            lastSavedRef.current = null;
          }}
          className="mt-2 font-mono text-[10px] text-text-tertiary tracking-[0.1em] underline"
        >
          ОТКЛЮЧИТЬ
        </button>
      </div>
    );
  }

  return (
    <button
      onClick={() => {
        hapticImpact('medium');
        tonConnectUI.openModal();
      }}
      className="sliced w-full py-3.5 bg-accent text-bg-base display text-[13px] tracking-[0.1em]"
    >
      💎 ПОДКЛЮЧИТЬ TON-КОШЕЛЁК
    </button>
  );
}
